import React, {Component} from 'react'
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";

import {
    Divider,
    FormControl,
    List,
    ListItem,
    ListItemText,
    RadioGroup
} from "@material-ui/core";
import ZoomRecordingGroupInstance from "./ZoomRecordingGroupInstance";
import {__getValueIfAvailable, __isAvailable} from "../../_helpers/commons/utility.helper";
import {ZoomRecordingListDates} from "./ZoomRecordingListDates";
import ReactHtmlParser from 'react-html-parser';

// COMPONENT ##########################################################

class ZoomRecordingListings extends Component {

	constructor(props) {
		super(props);
		this.handleMeetingAccordion  = this.handleMeetingAccordion.bind(this);
	}

    state = {
        expandedMeetings: new Set(),
    };

    componentDidMount() {
        const {zoom} = this.props;
        const {data} = zoom.getRecordings;
        const {meetings} = data;

        this.expandFirstNonEmptyMeeting(meetings);  // expand the first non-empty meeting
    }

    expandFirstNonEmptyMeeting = (meetings) => {
        if(__isAvailable(meetings)) {
            // expand the first meeting that has at least one recording by default
            const firstNonEmptyMeeting = meetings.find(function(meeting) {
                if(meeting.recording_files.length > 0) { return meeting; }
            });
            const expandUuid = __isAvailable(firstNonEmptyMeeting)
                                    ? firstNonEmptyMeeting.uuid     // first meeting with some recording
                                    : meetings[0].uuid;             // fallback

            let {expandedMeetings} = this.state;
            expandedMeetings.add(expandUuid);                       // add it to the list
            this.setState({expandedMeetings: expandedMeetings});
        }
    };

    handleMeetingAccordion = uuid => {
        let {expandedMeetings} = this.state;
        (expandedMeetings.has(uuid))            // check presence for toggling
            ?   expandedMeetings.delete(uuid)   // delete, if present
            :   expandedMeetings.add(uuid);     // add, if not present yet

        this.setState({expandedMeetings: expandedMeetings});
    };

    isRecordingsAvailable = (meetings) => __isAvailable(meetings);

    isExpanded = (uuid) => this.state.expandedMeetings.has(uuid);

    render() {
        const {t, zoom} = this.props;
        const {data} = zoom.getRecordings;
        const {meetings} = data;
        const isRecordingAvailable = this.isRecordingsAvailable(meetings);
        return (
            <List>
                <ListItem>
                    <ListItemText
                        secondary={t("Choose a meeting and recording to validate for creation of a new Gist.")}/>
                </ListItem>

                <ListItem>
                    <ListItemText primary={t("Meeting Recordings")}/>
                </ListItem>

	            {/* Add a divider for the heading */}
	            <Divider variant="fullWidth" />

	            {/* Date Viewer */}
	            <ListItem>
					<ZoomRecordingListDates
						updateRecordingList={this.props.updateRecordingList}
						data={data}
					/>
	            </ListItem>

	            {/* Add a divider for the date selector */}
	            <Divider variant="fullWidth" />

                {/* Form control for ordering gist for a recording */}
                <FormControl component="fieldset" fullWidth style={{maxHeight: '40vh', overflow: 'auto', maxWidth: this.props.maxWidth}}>
                    <RadioGroup name="order-recording">
                            {/* If there are recordings */}
                            { isRecordingAvailable &&
                                meetings.map(meeting =>
                                <ZoomRecordingGroupInstance
                                    key={meeting.uuid}
                                    meeting={meeting}
                                    isExpanded={this.isExpanded}
                                    handleMeetingAccordion={this.handleMeetingAccordion}
                                    handleSelectRecording={this.props.handleSelectRecording}
                                />
                            )}

                            {/* If there are no recordings */}
                            { !this.isRecordingsAvailable(meetings) &&
                                <ListItem>
                                    <ListItemText
                                        primary={t("There are no recordings available yet.")}
                                        secondary={
                                            ReactHtmlParser(`<br /><a href='https://support.zoom.us/hc/en-us/articles/203741855-Cloud-recording'>`
                                                                + t("Learn more about Cloud Recording with Zoom.")
                                                                + `</a>`)
                                        }
                                    />
                                </ListItem>
                            }

                    </RadioGroup>
                </FormControl>

                {/* Add a divider for the end-of-list */}
                <Divider variant="fullWidth" light />
            </List>
        )
    }
}

function mapStateToProps(state) {
    const { integrations } = state;
    const { zoom } = integrations;
    return {
        zoom,
    };
}

function mapDispatchToProps() {
    return {}
}

const connectedZoomRecordingListings = withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ZoomRecordingListings));
export { connectedZoomRecordingListings as ZoomRecordingListings };
